<div class="container">
    <div>
        <span *ngIf="!!stringDeliveryNumbers" [i18n]="'common.delivery-number'"></span>
        {{ stringDeliveryNumbers }}
    </div>
    <div *ngIf="!!stringSalesOrderNumbers">
        <span [i18n]="'common.sales-order-number'"></span>
        {{ stringSalesOrderNumbers }}
    </div>
</div>
